import Vue from 'vue'
import Router from 'vue-router'
import index from '../pages/mainView/index'
import Layout from "../pages/layout/Layout";
import AppLayout from "../pages/layout/AppLayout";
import {toPage} from "../utils/rem";

Vue.use(Router)
//  解决点击同一路由报错的问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


export const constantRouterMap = [
  {
    path: '/',
    redirect: '/index'
  },
  {
    component: Layout,
    path: '/',
    children: [
      {
        path: '/login',
        name: 'login',
        component: () => import('../pages/mainView/login/index'),
        hidden: true
      },
      {
        path: '/register',
        name: 'register',
        component: () => import('../pages/mainView/register/index'),
        hidden: true
      },
      {
        path: '/index',
        name: '首页',
        component: (resolve) => require(['../pages/mainView/index'], resolve)
      },
      {
        path: '/centerOverview',
        name: '医院概况',
        component: (resolve) => require(['../pages/mainView/centerOverview/CenterOverview'], resolve),
        children: [
          {
            path: '/centerOverview/hospitalIntroduction',
            name: '医院简介',
            component: (resolve) => require(['../pages/mainView/centerOverview/components/HospitalIntroduction'], resolve)
          },

          {
            path: '/centerOverview/culturalConstruction',
            name: '医院荣誉',
            component: (resolve) => require(['../pages/mainView/centerOverview/components/CulturalConstruction'], resolve)
          },
          {
            path: '/centerOverview/contactInformation',
            name: '联系我们',
            component: (resolve) => require(['../pages/mainView/centerOverview/components/ContactInformation'], resolve)
          }
        ]
      },
      {
        path: 'newsInformation',
        name: '新闻动态',
        component: (resolve) => require(['../pages/mainView/newsInformation/NewsInformation'], resolve),
        redirect: '/newsInformation/hospitalNews',
        children: [
          {
            path: '/newsInformation/hospitalNews',
            name: '医院新闻',
            component: (resolve) => require(['../pages/mainView/newsInformation/components/HospitalNews'], resolve)
          },
          {
            path: '/newsInformation/stopNotification',
            name: '职工文化',
            component: (resolve) => require(['../pages/mainView/newsInformation/components/StopNotification'], resolve)
          },
          {
            path: '/newsInformation/medicalDisclosure',
            name: '院务公开',
            component: (resolve) => require(['../pages/mainView/newsInformation/components/medicalDisclosure'], resolve)
          },
          {
            path: '/newsInformation/videoList',
            name: '精彩视频',
            component: (resolve) => require(['../pages/mainView/video/components/videoList'], resolve),
            hidden: true
          },
          {
            path: '/newsInformation/newsDetail',
            name: '新闻详情',
            component: (resolve) => require(['../pages/mainView/newsInformation/components/newsDetail'], resolve)
          },
          {
            path: '/newsInformation/departmentDynamics',
            name: '科室动态',
            component: (resolve) => require(['../pages/mainView/newsInformation/components/departmentDynamics'], resolve)
          },/*, {
            path: '/newsInformation/thirdClassReview',
            name: '三甲复审',
            component: (resolve) => require(['../pages/mainView/newsInformation/components/thirdClassReview'], resolve)
          }*/
          {
            path: '/newsInformation/videoDetails',
            name: '视频观看',
            hidden: true,
            component: (resolve) => require(['../pages/mainView/video/components/videoDetail'], resolve)
          },
          {
            path: '/newsInformation/jkkpList',
            name: '健康科普',
            component: (resolve) => require(['../pages/mainView/newsInformation/components/jkkpList'], resolve)
          },
          {
            path: '/newsInformation/gyhdList',
            name: '公益活动',
            component: (resolve) => require(['../pages/mainView/newsInformation/components/gyhdList'], resolve)
          },
        ]
      },
      {
        path: 'department',
        name: '科室导航',
        component: (resolve) => require(['../pages/mainView/doctorManagers/index'], resolve),
        redirect: '/department/doctors',
        children: [
          {
            path: '/department/doctors',
            name: '专家简介',
            component: (resolve) => require(['../pages/mainView/doctorManagers/components/doctors'], resolve)
          },
          {
            path: '/department/doctorDetail',
            name: '专家详细信息',
            component: (resolve) => require(['../pages/mainView/doctorManagers/components/doctorDetail'], resolve)
          },
        ]
      },
      {
        path: '/department/phone',
        name: '联系电话',
        component: (resolve) => require(['../pages/mainView/doctorManagers/components/phone'], resolve)
      },
      {
        path: 'otherpath',
        component: (resolve) => require(['../pages/mainView/columnList/index'], resolve),
        name: '项目导航',
        redirect: '/columnList/partyWork',
        children: [
          {
            path: '/columnList/partyWork',
            name: '党建工作',
            component: (resolve) => require(['../pages/mainView/columnList/components/partyWork'], resolve)
          },
          {
            path: '/gzwj/gzwjIndex',
            name: '规章文件',
            component: (resolve) => require(['../pages/mainView/columnList/components/gzwj'], resolve)
          },
          {
            path: '/department/knowledge',
            name: '专科知识',
            component: (resolve) => require(['../pages/mainView/columnList/components/knowledge'], resolve)
          },
          {
            path: '/other/newsDetail',
            name: '新闻详情',
            component: (resolve) => require(['../pages/mainView/columnList/components/NewsDetail'], resolve)
          }
        ]
      },
      {
        path: 'keyDepartments',
        name: '重点科室',
        component: (resolve) => require(['../pages/mainView/keyDepartments/index'], resolve),
        redirect: '/keyDepartments/components',
        children: [
          {
            path: '/keyDepartments/context',
            name: '科室信息',
            component: (resolve) => require(['../pages/mainView/keyDepartments/components/context'], resolve)
          }
        ]
      },
      {
        path: 'video',
        name: '精彩视频',
        component: (resolve) => require(['../pages/mainView/Video/index'], resolve),
        redirect: '/video/videoList',
        children: [
          {
            path: '/video/videoList',
            name: '精彩视频',
            component: (resolve) => require(['../pages/mainView/video/components/videoList'], resolve)
          },
          {
            path: '/video/videoDetails',
            name: '视频观看',
            hidden: true,
            component: (resolve) => require(['../pages/mainView/video/components/videoDetail'], resolve)
          }
        ]
      },
      {
        path: '/table/index',
        name: '出诊信息',
        component: (resolve) => require(['../pages/mainView/table/index'], resolve)
      },
      {
        path: '/announcementDynamics/index',
        name: '公告动态',
        component: (resolve) => require(['../pages/mainView/noticeAnnouncement/index'], resolve),
        children: [
          {
            path: '/announcementDynamics/noticeAnnouncement',
            name: '通知公告',
            component: (resolve) => require(['../pages/mainView/noticeAnnouncement/components/NoticeAnnouncement'], resolve)
          },
          {
            path: '/announcementDynamics/mediaFocus',
            name: '媒体聚焦',
            component: (resolve) => require(['../pages/mainView/noticeAnnouncement/components/mediaFocus'], resolve)
          },
          {
            path: '/announcementDynamics/noticeDetail',
            name: '公告详情',
            component: (resolve) => require(['../pages/mainView/noticeAnnouncement/components/noticeDetail'], resolve)
          }, {
            path: '/announcementDynamics/honestAdministration',
            name: '廉政监督',
            component: (resolve) => require(['../pages/mainView/noticeAnnouncement/components/honestAdministration'], resolve)
          }, {
            path: '/announcementDynamics/informationDisclosure',
            name: '信息公开',
            component: (resolve) => require(['../pages/mainView/noticeAnnouncement/components/InformationDisclosure'], resolve)
          }
        ]
      },
    ]
  },
  {
    path: '/news',
    component: Layout,
    meta: {title: '新闻管理', icon: 'newsRelease'},
    name: '新闻管理',
    children: [{
      path: '/news/newsRelease',
      name: '新闻发布',
      component: () => import('@/pages/mainView/newsRelease/index'),
      meta: {title: '新闻发布', icon: 'newsRelease'},
    }, {
      path: '/newsAdd',
      name: 'newsAdd',
      hidden: true,
      component: () => import('@/pages/mainView/newsRelease/components/newsAdd'),
      meta: {title: '新闻添加', icon: 'newsRelease'}
    }, {
      path: '/newsExamine',
      name: 'newsExamine',
      hidden: true,
      component: () => import('@/pages/mainView/newsRelease/components/NewsExamine'),
      meta: {title: '新闻审核', icon: 'newsRelease'}
    }]
  },
]

export const constantRouterMapApp = [
  {
    path: '/',
    redirect: '/index'
  },
  {
    path: '/',
    component: AppLayout,
    children: [
      {
        path: '/index',
        name: '首页',
        component: (resolve) => require(['../pages/appView/index/index'], resolve)
      },
      {
        path: '/centerOverview',
        name: '医院概况',
        component: (resolve) => require(['../pages/appView/centerOverview'], resolve),
        children: [
          {
            path: '/centerOverview/hospitalIntroduction',
            name: '医院简介',
            component: (resolve) => require(['../pages/appView/centerOverview/components/HospitalIntroduction'], resolve)
          },

          {
            path: '/centerOverview/culturalConstruction',
            name: '医院荣誉',
            component: (resolve) => require(['../pages/appView/centerOverview/components/CulturalConstruction'], resolve)
          },
        ]
      },
      {
        path: 'newsInformation',
        name: '新闻动态',
        component: (resolve) => require(['../pages/appView/newsInformation'], resolve),
        redirect: '/newsInformation/hospitalNews',
        children: [
          {
            path: '/newsInformation/hospitalNews',
            name: '医院新闻',
            component: (resolve) => require(['../pages/appView/newsInformation/components/context1'], resolve)
          },
          {
            path: '/newsInformation/newsDetail',
            name: '新闻详情',
            component: (resolve) => require(['../pages/appView/newsInformation/components/NewsDetail'], resolve),
            hidden: true
          },
          {
            path: '/newsInformation/medicalDisclosure',
            name: '院务公开',
            component: (resolve) => require(['../pages/appView/newsInformation/components/context3'], resolve)
          },
          {
            path: '/video/videoList',
            name: '精彩视频',
            component: (resolve) => require(['../pages/appView/video/components/videoList'], resolve)
          },
          {
            path: '/newsInformation/thirdClassReview',
            name: '职工文化',
            component: (resolve) => require(['../pages/appView/newsInformation/components/context5'], resolve)
          },
          {
            path: '/newsInformation/jkkpList',
            name: '健康科普',
            component: (resolve) => require(['../pages/appView/newsInformation/components/jkkpList'], resolve)
          },
          {
            path: '/newsInformation/gyhdList',
            name: '公益活动',
            component: (resolve) => require(['../pages/appView/newsInformation/components/gyhdList'], resolve)
          },
        ]
      },
      /*{
        path: 'otherpath',
        component: (resolve) => require(['../pages/appView/newsInformation'], resolve),
        name: '项目导航',
        redirect: '/columnList/partyWork',
        children: [

          /!*{
            path: '/other/newsDetail',
            name: '新闻详情',
            component: (resolve) => require(['../pages/mainView/columnList/components/NewsDetail'], resolve)
          },*!/
        ]
      },*/
      {
        path: '/gzwj/gzwjIndex',
        name: '规章文件',
        component: (resolve) => require(['../pages/appView/newsInformation/components/context15'], resolve)
      },
      {
        path: 'video',
        name: '精彩视频',
        component: (resolve) => require(['../pages/appView/Video/index'], resolve),
        redirect: '/video/videoList',
        hidden: true,
        children: [
          {
            path: '/video/videoList',
            name: '精彩视频',
            component: (resolve) => require(['../pages/appView/video/components/videoList'], resolve)
          },
          {
            path: '/video/videoDetails',
            name: '视频观看',
            hidden: true,
            component: (resolve) => require(['../pages/appView/video/components/videoDetail'], resolve)
          }
        ]
      },
      {
        path: '/columnList/partyWork',
        name: '党建工作',
        component: (resolve) => require(['../pages/appView/newsInformation/components/context16'], resolve)
      },
      {
        path: '/department/knowledge',
        name: '专科知识',
        component: (resolve) => require(['../pages/appView/newsInformation/components/context17'], resolve)
      },
      {
        path: 'department',
        name: '科室导航',
        component: (resolve) => require(['../pages/appView/doctorManagers/index'], resolve),
        redirect: '/department/doctors',
        children: [
          {
            path: '/department/doctors',
            name: '专家简介',
            component: (resolve) => require(['../pages/appView/doctorManagers/components/doctors'], resolve)
          },
          {
            path: '/department/doctorDetail',
            hidden: true,
            name: '专家详细信息',
            component: (resolve) => require(['../pages/appView/doctorManagers/components/doctorDetail'], resolve)
          },
        ]
      },
      {
        path: 'keyDepartments',
        name: '重点科室',
        component: (resolve) => require(['../pages/appView/keyDepartments/index'], resolve),
        redirect: '/keyDepartments/components',
        hidden: true,
        children: [
          {
            path: '/keyDepartments/departments',
            name: '科室信息',
            component: (resolve) => require(['../pages/appView/keyDepartments/components/Departments'], resolve)
          },
          {
            path: '/keyDepartments/context',
            name: '科室详情',
            component: (resolve) => require(['../pages/appView/keyDepartments/components/context'], resolve),
            hidden: true
          }
        ]
      },
      {
        path: '/announcementDynamics/index',
        name: '公告动态',
        component: (resolve) => require(['../pages/appView/newsInformation'], resolve),
        hidden: true,
        children: [
          {
            path: '/announcementDynamics/noticeAnnouncement',
            name: '通知公告',
            component: (resolve) => require(['../pages/appView/newsInformation/components/context11'], resolve)
          },
          {
            path: '/announcementDynamics/mediaFocus',
            name: '媒体聚焦',
            component: (resolve) => require(['../pages/appView/newsInformation/components/context12'], resolve)
          },
          {
            path: '/announcementDynamics/noticeDetail',
            name: '公告详情',
            hidden: true,
            component: (resolve) => require(['../pages/appView/newsInformation/components/NewsDetail1'], resolve)
          }, {
            path: '/announcementDynamics/informationDisclosure',
            name: '信息公开',
            component: (resolve) => require(['../pages/appView/newsInformation/components/context13'], resolve)
          }, {
            path: '/announcementDynamics/honestAdministration',
            name: '廉政监督',
            component: (resolve) => require(['../pages/appView/newsInformation/components/context14'], resolve)
          }
        ]
      },
      {
        path: '/centerOverview/contactInformation',
        name: '联系我们',
        component: (resolve) => require(['../pages/appView/centerOverview/components/ContactInformation'], resolve)
      }
    ]
  }
]


export default new Router({
  routes: toPage() === 'index' ? constantRouterMap : constantRouterMapApp,
  mode: 'history',
  //在此处加入
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {x: 0, y: 0}
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js